import Chart from "react-apexcharts";
import _cloneDeep from "lodash/cloneDeep";

const BarChart = ({ series, options }) => {

  const safeOptions = _cloneDeep(options);
  const safeSeries = _cloneDeep(series);

  return (
    <Chart
      options={safeOptions}
      series={safeSeries}
      type="bar"
      stacked={true}
      width="100%"
      height="100%"
    />
  );
};

export default BarChart;
